
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTitleContainer as ObcTitleContainerElement} from '@oicl/openbridge-webcomponents/dist/components/title-container/title-container.js';
 
 
 

 
 export const ObcTitleContainer = createComponent({
   react: React,
   tagName: 'obc-title-container',
   elementClass: ObcTitleContainerElement,
   events: {
     
     onActionClick: 'action-click' as EventName<CustomEvent<{action: number}>>,
   }
  });
 
 